import { type OpzlyExperimentName } from '../config';

import { type AxiosCompatibleError } from '@/modules/http/types';
import { getLogger } from '@/modules/observability/logging';

/**
 * Logs bucketing errors with consistent format
 */
export function logBucketingError(
  experimentNames: OpzlyExperimentName[],
  error: unknown,
  retries?: number
): void {
  const isServer = typeof window === 'undefined';
  const message = isServer
    ? `[Server-side bucketing] Failed to bucket experiments: ${experimentNames.join(', ')}`
    : `[JIT Bucketing] bucketing call failed for ${experimentNames.join(', ')}${retries ? ` after ${retries} retries` : ''}.`;

  getLogger().warn(message, {
    error: {
      message:
        (error as AxiosCompatibleError)?.response?.data ||
        (error as Error)?.message,
      stack: (error as Error)?.stack,
    },
    http: {
      status_code: (error as AxiosCompatibleError)?.code,
    },
  });
}
